import { useBreakpoint } from "@/base/utils/index";
import { skeletonPrefixCls } from "@/base/components/index";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css`
    aspect-ratio: 1 / 1;
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
    border-radius: 4px;
    img {
      object-fit: contain;
    }
  `,
  image: css`
    width: 100%;
  `,
  skeleton: css`
    display: block !important;
    position: absolute !important;
    inset: -4px !important;

    .${skeletonPrefixCls}-image {
      width: 100% !important;
      height: 100% !important;
    }
  `,
}));

export const useProductImageStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
